export const featuredPortfolio = [
    {
      id: 1,
      title: "SoulX",
      img:
        "https://i.pinimg.com/564x/05/68/81/056881aee7dfc62b02fb319f16acbbb1.jpg",
      link:"#intro",
    },
    {
      id: 2,
      title: "Recipie React",
      img:
        "https://i.pinimg.com/564x/3d/ee/3c/3dee3cbd6d9e31c85e530cdbbcb0b66f.jpg",
      link:"https://parthpradhan.github.io/recipiehome/#/",
    },
    {
      id: 3,
      title: "SoulFrost",
      img:
        "https://i.pinimg.com/564x/ed/10/10/ed1010b049e30e4bdd31d43b6a1ec4c6.jpg",
      link:"https://parthpradhan.github.io/soulfrostgem.io/",
    },
    {
      id: 4,
      title: "F.P.S",
      img:
        "https://i.pinimg.com/564x/77/ae/cc/77aeccfb9976e61fea28dfc8aba7adab.jpg",
      link:"https://parthpradhan.github.io/index2.html",
    },
    {
      id: 5,
      title: "Spam Bot",
      img:
        "https://i.pinimg.com/564x/57/02/fb/5702fb9a1f14e7f6e350b84f42a5ca0c.jpg",
      link:"https://parthpradhan.github.io/index2.html",
    },
    {
      id: 6,
      title: "Qweet",
      img:
        "https://i.pinimg.com/564x/b8/04/85/b804855b3c4bc76de654563f8fce1b3d.jpg",
      link:"https://parthpradhan.github.io/quotegen/",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "First Webiste :D",
      img: "https://i.pinimg.com/564x/19/41/55/19415588aec65d1f478c9a472585e0ef.jpg",
      link:"https://parthpradhan.github.io/",
    },
    {
      id: 2,
      title: "SoulFrost",
      img: "https://i.pinimg.com/564x/ed/10/10/ed1010b049e30e4bdd31d43b6a1ec4c6.jpg",
      link:"https://parthpradhan.github.io/soulfrostgem.io/",
    },
    {
      id: 3,
      title: "SoulX",
      img: "https://i.pinimg.com/564x/05/68/81/056881aee7dfc62b02fb319f16acbbb1.jpg",
      link:"#intro",
    },
    {
      id: 4,
      title: "Recipie React",
      img: "https://i.pinimg.com/564x/3d/ee/3c/3dee3cbd6d9e31c85e530cdbbcb0b66f.jpg",
      link:"https://parthpradhan.github.io/recipiehome/#/",
    },
    {
      id: 5,
      title: "SearchX",
      img: "https://i.pinimg.com/564x/5c/ae/8e/5cae8ef52aecb2f185b65787d296eb9a.jpg",
      link:"https://parthpradhan.github.io/hotshot/#/",
    },
    {
      id: 6,
      title: "Qweet",
      img: "https://i.pinimg.com/564x/b8/04/85/b804855b3c4bc76de654563f8fce1b3d.jpg",
      link :"https://parthpradhan.github.io/quotegen/",
    },
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Qweet",
      img: "https://i.pinimg.com/564x/29/6f/39/296f39ebf197a325f639dfdf73421557.jpg",
      link:"#intro",
    },
    {
      id: 2,
      title: "Recipie React",
      img: "https://i.pinimg.com/564x/3a/3a/e3/3a3ae3ee562ce28424625b8e124d14ed.jpg",
      link:"https://parthpradhan.github.io/recipiehome/#/casestudy",
    },
    {
      id: 3,
      title: "x",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
      link:"#",
    },
    {
      id: 4,
      title: "x",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
      link:"#",
    },
    {
      id: 5,
      title: "x",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
      link:"#i",
    },
    {
      id: 6,
      title: "x",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
      link:"#",
    },
  ];
  
  export const artPortfolio = [
    {
      id: 1,
      title: "Alexir",
      img: "https://i.pinimg.com/564x/06/e2/e0/06e2e092cfcef492ed8563bbaa1dcf8b.jpg",
      link:"https://parthpradhan.github.io/alexir",
    },
    {
      id: 2,
      title: "Pinterest",
      img: "https://logos-world.net/wp-content/uploads/2020/09/Pinterest-Logo.png",
      link:"https://in.pinterest.com/TheParthPradhan/_created/",
    }
  ];
  